/**
 * LinkOffIcon/index.js
 * desc: system icon for a broken collection link (unmatched linked field)
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LinkOffIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="link-off icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.linkOff.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fillRule="evenodd" clipRule="evenodd" d="M17.9194 1.00956L18.9904 2.08057C20.3365 3.42665 20.3365 5.63052 18.9904 6.9766L16.1534 9.81363C15.0922 10.8765 13.4954 11.0979 12.2079 10.4842L17.2309 5.46124C17.7274 4.9648 17.7274 4.15422 17.2309 3.65941L16.2592 2.68769C15.7628 2.19125 14.9538 2.19125 14.4574 2.68769L9.46531 7.67813C8.91679 6.4118 9.15605 4.87853 10.1864 3.84822L13.025 1.00956C14.3711 -0.336521 16.5733 -0.336521 17.9194 1.00956ZM13.0104 19.0116L14.0488 18.7967L13.3782 15.5593L12.3414 15.7774L13.0104 19.0116ZM5.92187 0.350356L6.94893 0.0964396L7.75463 3.29644L6.72757 3.55687L5.92187 0.350356ZM16.7426 17.2195L17.48 16.4594L15.1084 14.1579L14.3711 14.9196L16.7426 17.2195ZM19.1451 13.7965L19.4185 12.7744L16.2283 11.9182L15.9532 12.942L19.1451 13.7965ZM0.413835 6.58759L0.708444 5.5703L3.8824 6.47365L3.5943 7.4942L0.413835 6.58759ZM2.17823 2.79512L2.92859 2.04639L5.26267 4.3821L4.51556 5.13245L2.17823 2.79512ZM1.00956 17.9194L2.08057 18.9904C3.42665 20.3365 5.62889 20.3365 6.9766 18.9904L9.81363 16.1534C10.8765 15.0922 11.0979 13.4954 10.4842 12.2079L5.46124 17.2309C4.9648 17.7274 4.15422 17.7274 3.65941 17.2309L2.68769 16.2592C2.19125 15.7628 2.19125 14.9522 2.68769 14.4557L7.67976 9.46531C6.4118 8.91679 4.88016 9.15605 3.84822 10.188L1.00956 13.025C-0.336521 14.3711 -0.336521 16.5733 1.00956 17.9194Z"/></svg>
    </IconButton>
);


export default LinkOffIcon;
